<template>
  <v-container
    fluid
    class="d-flex flex-column justify-start align-center"
    style="height: 100%"
  >
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <DashboardHeader v-if="!loading" :details="details" />
    <DashboardTable v-if="!loading" :projects="details.history.slice(0, 4)" />
    <PartnerSpotlight v-if="!loading" />
    <v-divider v-if="!loading && showActivities"></v-divider>
    <Activities
      v-if="!loading && showActivities"
      :activities="details.activity"
    />
  </v-container>
</template>

<script>
import * as Sentry from "@sentry/vue";
import DashboardHeader from "./DashboardHeader.vue";
import DashboardTable from "./DashboardTable.vue";
import Activities from "./Activities.vue";
import PartnerSpotlight from "./PartnerSpotlight.vue";
import dashboard from "@/api/dashboard";
export default {
  name: "Dashboard",
  components: {
    DashboardHeader,
    DashboardTable,
    PartnerSpotlight,
    Activities,
  },
  data() {
    return {
      loading: true,
      showActivities: false,
      details: {},
    };
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const response = await dashboard.fetchDashboard();
        if (response.code == 200) {
          this.details = response.data;
          this.loading = false;
        } else {
          console.error(response);
        }
      } catch (error) {
        Sentry.captureException(error);
      }
    },
  },
  async activated() {
    await this.fetchData();
  },
};
</script>

<style scoped>
.v-divider {
  width: 97% !important;
  margin-top: 1rem !important;
}
</style>
